import React from "react";
import { Link } from "react-router-dom";

const AdminSidebar = () => {
    return (
        <div>
            <h4>Admin Panel</h4>
            <ul>
                <li>
                    <Link to="/admin/dashboard">Dashboard</Link>
                </li>
                <li>
                    <Link to="/admin/users">Users</Link>
                </li>
                <li>
                    <Link to="/admin/reports">Reports</Link>
                </li>
                <li>
                    <Link to="/admin/settings">Settings</Link>
                </li>
                <li>
                    <Link to="/admin/useful-links">Useful Links</Link>
                </li>
            </ul>
        </div>
    );
};

export default AdminSidebar;